// eslint-disable-next-line import/no-unresolved, import/extensions
import Privacy from './PrivacyVOI';

export default Privacy;
